/* eslint 'array-callback-return': 'off'  */
import React, { Component } from 'react';
import SearchInput, { createFilter } from 'react-search-input';
import { Table } from 'reactstrap';

const KEYS_TO_FILTERS = ['SiteName','PanelName', 'EquipmentName'];

export default class MeterSearchableDropDown extends Component {

    constructor(props) {
        super(props);
        this.state = {
            searchTerm: '',
        }
        this.searchUpdated = this.searchUpdated.bind(this);
        this.selectOption = this.selectOption.bind(this);
    }   

    searchUpdated(term) {
        this.setState({ searchTerm: decodeURIComponent(encodeURIComponent(term)) });
        
    }

    selectOption(id,name,dimensionId,defaultUnitId,siteId,siteName){
        this.props.setValue(id,name,dimensionId,defaultUnitId,siteId,siteName);
    }

    render(){
        var data = this.props.data;
        let FilteredData, Meters;
        let SelectedMeter = ""; 

        if (data !== undefined && data.length > 0 && data !== null) {

            FilteredData = data.filter(createFilter(this.state.searchTerm, KEYS_TO_FILTERS));
            if (FilteredData.length !== 0) {
                Meters = FilteredData.map(el => {
                    var HasChecked = this.props.selectedEquipment === el.EquipmentId ? true : false;
                    if(HasChecked){
                        SelectedMeter = el;
                    }else{
                    return <tr key={el.tenantId}>
                        <th style={{width:"5%", bordertop: "0 solid"}}><input type="radio" checked={HasChecked} id={el.EquipmentId} data-value={el.EquipmentName} onChange={() =>{this.selectOption(el.EquipmentId,el.EquipmentName,el.DimensionId,el.DefaultUnitId,el.SiteId,el.SiteName)}} /></th>
                        <td style={{width:"30%", bordertop: "0 solid"}}>{el.SiteName}</td>
                        <td style={{width:"30%", bordertop: "0 solid"}}>{el.PanelName}</td>
                        <td style={{width:"35%", bordertop: "0 solid"}}>{el.EquipmentName}</td>
                    </tr>
                    }
                });
            }
            else {
                Meters = <tr><td colSpan="3">No Records found</td></tr>
            }
        }
        else {
            Meters = <tr><td colSpan="3">No Records found</td></tr>
        }
        return(
            <div ref={this.props.refMethod} style={this.props.elementStyle}>
            <SearchInput className="search-input meter" onChange={(term)=>{this.searchUpdated(term)}} style={{width:"370px",float:"right","margin-top":"5px","margin-bottom":"5px","margin-left":"6px","margin-right":"6px",height:'40px'}} />
                <Table style={{ bordertop: "0 solid" }}>
                    <tbody>
                        <tr>
                            <th></th>
                            <th>SiteName</th>
                            <th>PanelName</th>
                            <th>PointName</th>
                        </tr>
                        {
                            SelectedMeter !== "" ?
                                <tr key={SelectedMeter.tenantId}>
                                    <th style={{ width: "5%", bordertop: "0 solid" }}><input type="radio" checked="true" id={SelectedMeter.EquipmentId} data-value={SelectedMeter.EquipmentName} onChange={() => { this.selectOption(SelectedMeter.EquipmentId, SelectedMeter.EquipmentName, SelectedMeter.DimensionId, SelectedMeter.DefaultUnitId, SelectedMeter.SiteId, SelectedMeter.SiteName) }} /></th>
                                    <td style={{ width: "30%", bordertop: "0 solid" }}>{SelectedMeter.SiteName}</td>
                                    <td style={{ width: "30%", bordertop: "0 solid" }}>{SelectedMeter.PanelName}</td>
                                    <td style={{ width: "35%", bordertop: "0 solid" }}>{SelectedMeter.EquipmentName}</td>
                                </tr> : ""
                        }
                        {Meters}
                    </tbody>
                </Table>
            </div>
        );
    }
}